import { isSafari } from "@/lib/safari";

export default function GrainOverlay() {
  // Safari: disable grain animation entirely (the transform animation causes repaints)
  // Still show the static texture, just no animation
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        top: "-50%",
        left: "-50%",
        width: "200%",
        height: "200%",
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
        pointerEvents: "none",
        zIndex: 9998,
        opacity: isSafari ? 0.2 : 0.4,
        animation: isSafari ? "none" : "grain 8s steps(10) infinite",
      }}
    />
  );
}
